import { render, staticRenderFns } from "./FormCustomValidation.vue?vue&type=template&id=15198733&"
import script from "./FormCustomValidation.vue?vue&type=script&lang=js&"
export * from "./FormCustomValidation.vue?vue&type=script&lang=js&"
import style0 from "./FormCustomValidation.vue?vue&type=style&index=0&id=15198733&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports